import emptyFunction from 'react-utils/emptyFunction';
import { ViewTabsContainer } from '../../tabs/components/ViewTabsContainer';
import styled from 'styled-components';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingName = styled.div.withConfig({
  displayName: "PinnedViewsLoadingSkeleton__LoadingName"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return `
  height: 100%;
  width: 100%;
  background: linear-gradient(to right, ${theme.color['fill-tertiary-hover']}, ${theme.color['fill-tertiary-default']} 20%, ${theme.color['fill-tertiary-hover']} 40%);
  background-size: 1200;
`;
});
const LoadingTab = ({
  first,
  last,
  tabStyle
}) => {
  return /*#__PURE__*/_jsx(View, {
    blockSize: "40px",
    backgroundColor: "fill-surface-default",
    borderColor: "border-core-subtle",
    borderStyle: "solid",
    borderBlockStartWidth: "100",
    borderBlockEndWidth: "0",
    borderInlineStartWidth: "100",
    borderInlineEndWidth: "100",
    borderStartStartRadius: tabStyle === 'modern' && first ? '100' : '0',
    borderStartEndRadius: tabStyle === 'modern' && last ? '100' : '0',
    children: /*#__PURE__*/_jsx(LoadingName, {})
  });
};
export const PinnedViewsLoadingSkeleton = ({
  tabStyle = 'legacy'
}) => {
  return /*#__PURE__*/_jsxs(ViewTabsContainer, {
    onReorder: emptyFunction,
    containerRef: emptyFunction,
    children: [/*#__PURE__*/_jsx(LoadingTab, {
      first: true,
      tabStyle: tabStyle
    }), /*#__PURE__*/_jsx(LoadingTab, {
      tabStyle: tabStyle
    }), /*#__PURE__*/_jsx(LoadingTab, {
      tabStyle: tabStyle
    }), /*#__PURE__*/_jsx(LoadingTab, {
      tabStyle: tabStyle
    }), /*#__PURE__*/_jsx(LoadingTab, {
      last: true,
      tabStyle: tabStyle
    })]
  });
};